import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css'; // Import your styles

const Support = () => {
  return (
    <div className="container">
      <div className="content">
        <h1 className="app-heading">Support for "Improv(e) Your Start at UM!"</h1>
        <p className="app-text">
          Welcome to the support page for "Improv(e) Your Start at UM!" We're delighted that you're interested in our app designed to enhance the first-year experience at Maastricht University. Here, you'll find answers to frequently asked questions, troubleshooting tips, and contact information for further assistance.
        </p>

        <h2 className="app-heading">Frequently Asked Questions (FAQs)</h2>
        <p className="app-text">
          <strong>How Do I Get Started?</strong>
          <br />
          Simply download the app from the App Store and follow the on-screen instructions to create an account using your SONA ID.
        </p>

        <p className="app-text">
          <strong>What Are Improv Dailies?</strong>
          <br />
          Improv Dailies are quick, engaging exercises based on improvisational theater. They are designed to boost your resilience, creativity, and connectedness.
        </p>

        <p className="app-text">
          <strong>How Do the Reflections Work?</strong>
          <br />
          Reflections are moments for you to pause and think about your experiences. They focus on key life skills like resilience and social integration.
        </p>

        <p className="app-text">
          <strong>What Are SONA Credits?</strong>
          <br />
          For participating in all five surveys within the app, you will earn 1 SONA credit, which can be useful for your academic journey.
        </p>

        <h2 className="app-heading">Troubleshooting</h2>
        <p className="app-text">
          <strong>The App Isn't Loading Properly</strong>
          <br />
          Try restarting the app or your device. If the issue persists, please update the app to the latest version.
        </p>

        <p className="app-text">
          <strong>I Can't Log In</strong>
          <br />
          Make sure you're using your SONA ID to log in. If you've forgotten your password, use the "Forgot Password" link to reset it.
        </p>

        <h2 className="app-heading">Contact Us</h2>
        <p className="app-text">
          For further assistance or to report any issues, please email us at{' '}
          <a href="mailto:a.nubold@maastrichtuniversity.nl">a.nubold@maastrichtuniversity.nl</a>.
        </p>
        <Link to="/" className="back-link">
          Go back to Home
        </Link>
      </div>
    </div>
  );
};

export default Support;
